import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const propTypes = {
  authentication: PropTypes.object,
  logout: PropTypes.func,
};

const LogoutButton = (props) => {
  const { authentication } = props;

  if (!authentication || !authentication.isAuthenticated) {
    return null;
  }

  return (
    <button
      className="logout-button"
      type="button"
      onClick={props.logout}
    >
      <FormattedMessage id="logout.send" />
    </button>
  );
};

LogoutButton.propTypes = propTypes;

export default LogoutButton;
